import classNames from 'classnames';

import { SectionTitle, TextBlock } from '@/ui/index';

import styles from './WhyBlock.module.scss';

const WhyBlock = ({ data, className }) => {
  const renderSubtextAlign = (item) => {
    let content = '';
    if (item?.subtext_align === 'left') {
      content = (
        <>
          <span className={styles.why__subtext}>{item?.subtext}</span>
          <strong className={styles.why__text}>{item?.text}</strong>
        </>
      );
    } else {
      content = (
        <>
          <strong className={styles.why__text}>{item?.text}</strong>
          <span className={styles.why__subtext}>{item?.subtext}</span>
        </>
      );
    }

    return content;
  };

  return (
    <section className={classNames(styles['why-block'], className)}>
      {!!data?.title && (
        <div className={styles.topWrapper}>
          <SectionTitle
            titleModify={classNames(styles['why-block__title'], 'title--large')}
          >
            {data.title}
          </SectionTitle>
          {!!data?.description && (
            <TextBlock
              className={classNames(styles['why-block__text'], 'text--large')}
              isHtml
            >
              {data.description}
            </TextBlock>
          )}
        </div>
      )}
      <div className={styles['why-block__content']}>
        <div className={styles.why}>
          {data?.items?.map((item) => (
            <div className={styles.why__item} key={item?.id}>
              <div className={styles.why__value}>
                {item?.subtext && renderSubtextAlign(item)}
              </div>
              <span className={styles.why__name}>{item?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyBlock;
